<template>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center">
      <h2 class="card-title">{{ 'onboarding.welcome' | translate }}</h2>
    </v-card-title>

    <v-card-content>
      <div class="content-wrapper">
        <div class="sections-container">
          <!-- First Setup Section -->
          <div class="section">
            <h3 class="section-title">{{ 'onboarding.first_setup' | translate }}</h3>
            <div class="video-placeholder" @click="openVideo('setup')">
              <div class="video-overlay">
                <div class="video-duration">{{ 'onboarding.watch' | translate }} {{ 'onboarding.first_setup' | translate }}</div>
              </div>
              <img :src="setupThumbnail" alt="First Setup Video" class="video-thumbnail" />
            </div>
          </div>

          <!-- Website Guide Section -->
          <div class="section">
            <h3 class="section-title">{{ 'onboarding.website_guide' | translate }}</h3>
            <div class="video-placeholder" @click="openVideo('guide')">
              <div class="video-overlay">
                <div class="video-duration">{{ 'onboarding.watch' | translate }} {{ 'onboarding.website_guide' | translate }}</div>
              </div>
              <img :src="guideThumbnail" alt="Website Guide Video" class="video-thumbnail" />
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="actions-section">
          <div class="info-section">
            <div class="d-flex align-center">
              <span>{{ 'onboarding.also_tip' | translate }}</span>
              <span><svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="38" height="38" rx="10" fill="#1DA643" />
                  <circle cx="19" cy="19" r="11.25" stroke="white" stroke-width="2" />
                  <circle cx="19" cy="26.5" r="0.625" fill="white" stroke="white" />
                  <path
                    d="M19 24V22.2264C19 21.0461 19.7553 19.9982 20.875 19.625V19.625C21.9947 19.2518 22.75 18.2039 22.75 17.0236V16.3821C22.75 14.3762 21.1238 12.75 19.1179 12.75H19C16.9289 12.75 15.25 14.4289 15.25 16.5V16.5"
                    stroke="white" stroke-width="2" />
                </svg>
              </span>
            </div>
          </div>
          <v-card-actions class="justify-end pa-0">
            <v-btn color="green darken-1" dark large @click="getStarted">
              {{ 'onboarding.button_start' | translate }}
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card-content>

    <!-- Video Modal -->
    <v-dialog v-model="videoModalOpen" max-width="1200" content-class="video-modal">
      <v-card class="video-modal-card">
        <v-card-title class="d-flex justify-space-between align-center pa-2">
          <h3>{{ currentVideoTitle }}</h3>
        </v-card-title>
        <div class="pa-0">
          <div class="video-container">
            <iframe v-if="currentVideoId" :src="youtubeEmbedUrl" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen class="video-iframe"></iframe>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'GettingStartedModal',
  data () {
    return {
      videoModalOpen: false,
      currentVideoId: null,
      currentVideoTitle: '',
      videos: {
        setup: {
          id: '9BAzImy71JA',
          title: this.$t('onboarding.first_setup'),
          url: 'https://youtu.be/9BAzImy71JA'
        },
        guide: {
          id: 'dL9_shptnHY',
          title: this.$t('onboarding.website_guide'),
          url: 'https://youtu.be/dL9_shptnHY'
        }
      },
      videos_ua: {
        setup: {
          id: 'XpYWPiGt_WU',
          title: this.$t('onboarding.website_guide'),
          url: 'https://youtu.be/XpYWPiGt_WU'
        },
        guide: {
          id: 'nI1ImXL3Cbc',
          title: this.$t('onboarding.website_guide'),
          url: 'https://youtu.be/nI1ImXL3Cbc'
        }
      },
    }
  },
  computed: {
    lang () {
      const language = this.$store.getters['account/lang']
      return language === 'us' ? 'en' : language
    },
    currentVideos () {
      return this.lang === 'uk' ? this.videos_ua : this.videos
    },
    setupThumbnail () {
      return `https://img.youtube.com/vi/${this.currentVideos.setup.id}/maxresdefault.jpg`
    },
    guideThumbnail () {
      return `https://img.youtube.com/vi/${this.currentVideos.guide.id}/maxresdefault.jpg`
    },
    youtubeEmbedUrl () {
      if (!this.currentVideoId) return ''
      return `https://www.youtube.com/embed/${this.currentVideoId}?autoplay=1&rel=0&modestbranding=1`
    }
  },
  methods: {
    openVideo (type) {
      const video = this.currentVideos[type]
      if (video) {
        this.currentVideoId = video.id
        this.currentVideoTitle = video.title
        this.videoModalOpen = true
      }
    },

    closeVideoModal () {
      this.videoModalOpen = false
      this.currentVideoId = null
      this.currentVideoTitle = ''
    },

    getStarted () {
      this.$emit('close')
      this.$emit('started')
    }
  }
}
</script>

<style scoped>
.v-card__content {
  margin-top: 1rem;
  border-top: 0.1rem solid #d7d7d7;
  padding: 2rem;
}

.card-title {
  font-size: 2.6rem;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;

}

.sections-container {
  display: flex;
  gap: 2rem;
  width: 100%;
}

.section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.section-title {
  color: #5EBE40;
  font-size: 3.6rem;
  font-weight: 500;
  margin-bottom: 1rem;
  text-align: left;
  font-weight: 900;
}

.video-placeholder {
  position: relative;
  background-color: #f5f5f5;
  border-radius: 8px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

}

.video-placeholder:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.video-placeholder:hover .video-overlay {
  background-color: rgba(0, 0, 0, 0.6);
}

.video-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: background-color 0.3s ease;
}

.video-duration {
  color: white;
  font-weight: 500;
  margin-top: 8px;
  font-size: 14px;
}

.info-section {
  width: 100%;
}

.info-section div {
  display: inline-flex;
  gap: 1rem;
}

.info-section span {
  font-weight: 700;
  font-size: 1.4rem;
}

.actions-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 2rem;
  border-top: 1px solid #D7D7D7;
}

.v-card__actions {
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.v-card__actions .v-btn {
  min-width: 150px;
}

/* Video Modal Styles */
.video-modal {
  margin: 0;
}

.video-modal-card {
  margin: 0;
}
.video-modal-card .v-card__title {
  margin-bottom: 2rem;
}

.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  /* 16:9 aspect ratio */
  background: #000;
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .v-card__actions {
    justify-content: center;
    margin-bottom: 2rem;
  }
  .actions-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .sections-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .v-card__content {
    padding: 1rem;
  }

  .section-title {
    font-size: 1.3rem;
  }

  .video-placeholder {
    height: 150px;
  }

  .video-container {
    padding-bottom: 75%;
    /* Adjusted for mobile */
  }
}

/* Deep selector for dialog */
:deep(.v-dialog.video-modal) {
  margin: 24px;
}

:deep(.v-dialog.video-modal .v-card) {
  margin: 0;
}
</style>